// extracted by mini-css-extract-plugin
export default {"page":"rE","top_block":"sE","heading":"tE","inner_text":"uE","starter_text":"vE","starter_cta":"wE","summary_block":"xE","cartsummary_wrap":"yE","price":"zE","pricing_wrap":"AE","summary_block_mob":"BE","summary":"CE","pricing_heading":"EE","products_summary":"FE","summary_line":"GE","summary_price":"HE","summary_title":"IE"};
    if(module.hot) {
      // 1715188236314
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  